
export enum MemberStatus {
    WAITING = 0,
    SCANNED,
    CANCELLED,
    NOSHOW
}
